import { Box, Image, Stack, Text, VStack } from "@chakra-ui/react";
import React from "react";
import { Img } from "../../../../content/Content";
import '../Chat.component.css'
const RightChat = () => {
  const GroupData = [
    {
      avatar: "",
      name: "Forex Agency",
      time1: "Des 12 2023",
      time2: "10:00 AM",
      avatrText: "FRX",
      color: "#92E0CD",
      colorText: "#21997C",
      status: true,
      groupPhoto: [
        {
          g1: Img.PostAvatar1,
          left: "-18px",
          zIndex: 0,
        },
        {
          g1: Img.PostAvatar2,
          left: "-6px",
          zIndex: 5,
        },
      ],
    },
    {
      avatar: "",
      name: "ABC Group",
      message: "it is a long establish fact",
      time1: "Des 12 2023",
      time2: "10:00 AM",
      avatrText: "BRQ",
      color: "rgba(91, 163, 228, 1)",
      colorText: "rgba(49, 125, 194, 1)",
      status: false,
      groupPhoto: [
        {
          g1: Img.PostAvatar1,
          left: "-18px",
          zIndex: 0,
        },
        {
          g1: Img.PostAvatar2,
          left: "-6px",
          zIndex: 5,
        },
      ],
    },
  ];
  const media =[
    {
        im:Img.media1
    },
    {
        im:Img.media2
    },
    {
        im:Img.media3
    },
    {
        im:Img.media4
    },
  ]
  return (
    <VStack w="100%" mx="20px" p="20px 30px" bg="#FFFFFF" borderRadius="18px" h="99%">
      <Stack>
        <Image src={Img.chatImage} w="288px" h="222px" />
        <Box
          w="220px"
          bg="#FFFFFF"
          h="96px"
          borderRadius="17px"
          mx="auto"
          display="flex"
          alignItems={"center"}
          flexDirection="column"
          justifyContent="center"
          position="relative"
          top="-40px"
        >
          <Text
            fontFamily=" Proxima Nova"
            fontSize="20px"
            fontWeight="400"
            textAlign="center"
            color="#8799CB"
          >
            FRX Educators
          </Text>
          <Text
            fontFamily="'Roboto', sans-serif"
            fontSize="20px"
            fontWeight="600"
            textAlign="center"
            color="#000000"
            pb="5px"
          >
            JC Morales
          </Text>
        </Box>

        <Box
          w="100%"
          borderTop="1px solid rgba(149, 151, 171, 1)"
          opacity="0.1"
        ></Box>
      </Stack>
      <Stack w="100%">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          w="100%"
        >
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="20px"
            fontWeight="600"
            textAlign="center"
            color="#000000"
          >
            User information's
          </Text>
          <Box h="10px" w="2px" bg="rgba(149, 151, 171, 1)"></Box>
        </Box>

        <Box w="100%" py="10px">
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="20px"
            fontWeight="600"
            textAlign="left"
            color="#000000"
          >
            Phone
          </Text>
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="20px"
            fontWeight="600"
            textAlign="left"
            color="rgba(149, 151, 171, 1)"
          >
            229.555.0109
          </Text>
        </Box>
        <Box w="100%" py="10px">
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="20px"
            fontWeight="600"
            textAlign="left"
            color="#000000"
          >
            Email
          </Text>
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="20px"
            fontWeight="600"
            textAlign="left"
            color="rgba(149, 151, 171, 1)"
          >
            229.555.0109
          </Text>
        </Box>

        <Box
          w="100%"
          borderTop="1px solid rgba(149, 151, 171, 1)"
          opacity="0.1"
        ></Box>
      </Stack>

      <Stack w="100%">
        <Box
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          w="100%"
        >
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="20px"
            fontWeight="600"
            textAlign="center"
            color="#000000"
          >
            Group Participant
          </Text>
          <Box h="10px" w="2px" bg="rgba(149, 151, 171, 1)"></Box>
        </Box>

        <Box w="100%" py="10px">
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="20px"
            fontWeight="600"
            textAlign="left"
            color="#000000"
          >
            Phone
          </Text>
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="20px"
            fontWeight="600"
            textAlign="left"
            color="rgba(149, 151, 171, 1)"
          >
            229.555.0109
          </Text>
        </Box>
        <Box w="100%" py="10px">
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="20px"
            fontWeight="600"
            textAlign="left"
            color="#000000"
          >
            Email
          </Text>
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="20px"
            fontWeight="600"
            textAlign="left"
            color="rgba(149, 151, 171, 1)"
          >
            229.555.0109
          </Text>
        </Box>

        <Box
          w="100%"
          borderTop="1px solid rgba(149, 151, 171, 1)"
          opacity="0.1"
        ></Box>
      </Stack>
      <Stack w="100%">
        {GroupData.map((item, id) => (
          <Stack flexDir="row" w="100%" py="15px" key={id}>
            <Box
              w="85%"
              display="flex"
              flexDir="row"
              justifyContent="space-between"
              alignItems="flex-start"
            >
              {item.avatar === "" ? (
                <Box
                  w="49px"
                  display="flex"
                  alignItems="center"
                  justifyContent="center"
                  h="49px"
                  borderRadius="8px"
                  bg={item.color}
                  color={item.colorText}
                >
                  {item.avatrText}
                </Box>
              ) : (
                <Image src={item.avatar} h="47px" w="47px" />
              )}
              <Box>
                <Text
                  fontFamily="'Roboto',sans-serif"
                  fontSize="20px"
                  fontWeight="500"
                >
                  {item.name}
                </Text>
                <Text
                  display="flex"
                  flexDir="row"
                  fontFamily="'Roboto',sans-serif"
                  fontSize="16px"
                  fontWeight="400"
                  pt="5px"
                  color=" rgba(149, 151, 171, 1)"
                >
                  {item.time1}
                  <Text mx="10px" color=" rgba(149, 151, 171, 1)">
                    {item.time2}
                  </Text>
                </Text>
              </Box>
            </Box>
            <Box
              w="15%"
              display="flex"
              flexDir="row"
              alignItems="flex-start"
              position="relative"
            >
              {item.groupPhoto.map((sm, id) => (
                <Box key={id} position="absolute" left={sm.left}>
                  <Image
                    src={sm.g1}
                    w="20px"
                    h="20px"
                    border="2px solid #fff"
                    borderRadius="10px"
                  />
                </Box>
              ))}
            </Box>
          </Stack>
        ))}
      </Stack>
      <Box
          w="100%"
          borderTop="1px solid rgba(149, 151, 171, 1)"
          opacity="0.1"
        ></Box>
      <Stack w="100%" py="10px">
      <Box
          display="flex"
          alignItems="flex-start"
          justifyContent="flex-start"
          w="100%"
        >
          <Text
            fontFamily="'Inter', sans-serif"
            fontSize="20px"
            fontWeight="600"
            textAlign="left"
            color="#000000"
          >
            Media
          </Text>
        
        </Box>
      </Stack>
        <Stack flexDir='row' alignItems='center' justifyContent='flex-start'>
            {
                media.map((item,index)=>(
                    <Box id={index}>
                        <Image src={item.im} w='55px'h='55px'borderRadius='7px'/>
                    </Box>
                ))
            }
        </Stack>
    </VStack>
  );
};

export default RightChat;
